import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { supabase } from '../config/supabase';

export default function SetPassword() {
  const [ready, setReady] = useState(false), [checking, setChecking] = useState(true), [busy, setBusy] = useState(false), [done, setDone] = useState(false);
  const [password, setPassword] = useState(''), [confirm, setConfirm] = useState(''), [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    const finish = (valid, message = '') => { if (active) { setReady(valid); setError(message); setChecking(false); } };
    // detectSessionInUrl exchanges Supabase's standard invite/recovery fragment.
    supabase.auth.getSession().then(async ({ data, error: sessionError }) => {
      if (sessionError || !data.session) return finish(false, 'This link is invalid or has expired. Request a new password reset from the sign-in page.');
      const verified = await supabase.auth.getUser();
      finish(!verified.error && !!verified.data.user, verified.error ? 'This link is invalid or has expired.' : '');
    }).catch(() => finish(false, 'Unable to verify this link. Please try again.'));
    return () => { active = false; };
  }, []);
  const submit = async e => {
    e.preventDefault(); setError('');
    if (password !== confirm) return setError('Passwords do not match.');
    if (password.length < 12) return setError('Use at least 12 characters.');
    setBusy(true);
    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      await supabase.auth.signOut({ scope: 'global' });
      setPassword(''); setConfirm(''); setDone(true);
    } catch (e) { setError(e.message); } finally { setBusy(false); }
  };
  return <Container className="py-5 text-start" style={{ maxWidth: 520 }}><Card><Card.Body className="p-4">
    <h1 className="h3">Set your password</h1><p className="text-muted">Choose a password for your Hestia admin account.</p>
    {error && <Alert variant="danger">{error}</Alert>}
    {checking ? <Spinner animation="border" role="status" /> : done ? <Alert variant="success">Your password has been saved. Sign in with your new password.</Alert> : ready && <Form onSubmit={submit}>
      <Form.Group controlId="setup-password" className="mb-3"><Form.Label>New password</Form.Label><Form.Control type="password" required minLength={12} autoComplete="new-password" value={password} onChange={e => setPassword(e.target.value)} /><Form.Text>At least 12 characters.</Form.Text></Form.Group>
      <Form.Group controlId="setup-confirm" className="mb-3"><Form.Label>Confirm password</Form.Label><Form.Control type="password" required autoComplete="new-password" value={confirm} onChange={e => setConfirm(e.target.value)} /></Form.Group>
      <Button type="submit" disabled={busy}>{busy ? 'Saving…' : 'Save password'}</Button>
    </Form>}
    <Link className="d-inline-block mt-3" to="/admin/login">Return to sign in</Link>
  </Card.Body></Card></Container>;
}
